<script>
  export let currentStep = 0;
</script>

<div class="progress">
  {#each Array(5) as _, index}
    <div 
      class="wave-dot"
      class:active={index === currentStep}
      class:done={index < currentStep}
    />
  {/each}
</div>
